module.exports = __webpack_public_path__ + "graphics/checkout-flow-family.ckh.23e934ad0898d21c54712d6999326c4a.svg";